export default __webpack_public_path__ + "static/media/arrow-plain-simple-right.de2bf177.svg";